<template>
  <div class="">
    <app-filter :hasFilter="hasFilter" @resetFilters="resetFilters" @changeFilters="changeFilters" :total="total"
                :bigTotal="bigTotal"
                label="Programme"
                :actions="actionButtons" :loading="loading">
      <div class="columns">
        <div class="column is-3 is-border-right is-border-bottom">
          <div class="field">
            <label class="label">Nom du programme</label>
            <div class="control">
              <input @change.prevent.stop="" v-model="filters.name" class="input" type="text">
            </div>
          </div>
        </div>
        <div v-if="isAdmin || isEditor" class="column is-3 is-border-right is-border-bottom">
          <div class="field" v-if="displayPromoteurSelect">
            <label class="label">Promoteur</label>
            <div class="control">
              <multiselect @select="updatePromoteurFilter" v-model="filters.promoteur" label="name" track-by="name"
                           :options="promoteurs" :searchable="true"  :show-labels="false"
                           class="multiselect--option-ico"
                           @search-change="getPromoteurs" :placeholder="''">
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="promoteurs.length"
                       @mousedown.prevent.stop="clearAll(props.search)"></div>
                </template>
                <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un promoteur</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="column is-3 is-border-right is-border-bottom">
          <label class="label">{{defaultStateLabel.label | cap}}</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.address__zip_code">
                <option :value="null">Sélectionner {{defaultStateLabel.label}}</option>
                <option v-for='s in states' :value="s.code" :key="s.code">{{s.name}} ({{s.code}})</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-3 is-border-right is-border-bottom">
          <label class="label">Date de livraison</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.date_livraison">
                <option :value="null">Sélectionner une date de livraison</option>
                <option v-for='trim in trimestrialsChoices' :value="trim[0]">{{trim[1]}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-3 is-border-right" v-if="isAdmin || isEditor">
          <label class="label">Multi-diffusion</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.diffusion_enabled">
                <option :value="null">Etat de la publication</option>
                <option :value="1">Activée</option>
                <option :value="0">Désactivée</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-3 is-border-right" v-if="isAdmin">
          <label class="label">Provenant de flux promoteur</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.from_flux">
                <option :value="null">Flux promoteur</option>
                <option :value="0">Non</option>
                <option :value="1">Oui</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="isAdmin" class="column is-3 is-border-right">
          <label class="label">Statut</label>
          <div class="columns is-multiline is-padding-top-small">
            <div class="control column is-narrow is-paddingless" v-for="(s, i) in workflowStatusList" :key="i">
              <input class="is-checkradio" :id="s.value" type="checkbox" :name="s.value" :value="s.value"
                     v-model="filters.status">
              <label :for="s.value">{{ s.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </app-filter>
    <div class="column has-bg-light is-border-bottom is-paddingless-top is-paddingless-bottom">
      <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                  :totalPage="totalPage"></pagination>
    </div>
    <div class="">
      <table v-show="!loading && items.length" class="table is-fullwidth is-marginless-bottom">
        <thead>
        <tr class="is-size-6">
          <th v-if="showColumn('picture')"></th>
          <th>
            <sortable @sort="sort('name', $event)" :sort="sortBy.name" label="Nom"></sortable>
          </th>
          <th v-if="(isAdmin || isEditor) && showColumn('status')">Statut</th>
          <th v-if="showColumn('progress_step')">État d'avancement</th>
          <th v-if="(isAdmin || isEditor) && showColumn('promotor_name')">
            <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name" label="Promoteur"></sortable>
          </th>
          <th v-if="(isAdmin || isEditor) && showColumn('diffusion_enabled')">
            <sortable @sort="sort('diffusion_enabled', $event)" :sort="sortBy.diffusion_enabled"
                      label="Publication en cours"></sortable>
          </th>
          <th v-if="showColumn('tax_dispositifs')">Dispositif fiscaux</th>
          <th v-if="showColumn('lot_dispo')">
            <sortable @sort="sort('lot_counts__available', $event)" :sort="sortBy.lot_counts__available"
                      label="Lots dispo"></sortable>
          </th>
          <th v-if="showColumn('lot_total')">
            <sortable @sort="sort('lot_counts__total', $event)" :sort="sortBy.lot_counts__total"
                      label="Lots Total"></sortable>
          </th>
          <th v-if="showColumn('city')">Ville</th>
          <th v-if="showColumn('date_livraison')">Date de livraison</th>
          <th v-if="!isExternal && showColumn('remuneration') && displayRemuneration">
            <sortable @sort="sort('remuneration', $event)" :sort="sortBy.remuneration"
                      label="Rémunération"></sortable>
          </th>
          <th v-if="isAdmin && showColumn('created_on')">
            <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on"
                      label="Date de création"></sortable>
          </th>
          <th class="has-text-centered">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                  <i class="fal fa-cog"></i>
                </button>
              </div>
              <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(program, i) in items" :key="program.pk" class="is-size-6">
          <td class="has-text-centered is-cell-hoverable" v-if="showColumn('picture')">
            <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}">
              <avatar :item="program" :i="i"></avatar>
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}" class="xfullLink">
              {{program.name | truncate}}
            </router-link>
            <span class="icon has-text-warning tooltip is-tooltip-bottom"
                  data-tooltip="Flux promoteur"
                  v-if="!isExternal && program.from_flux">
              <i class="fas fa-rss-square"></i>
            </span>
            <span class="tag is-exclusif" v-if="program.is_exclusive">Exclusivité</span>
            <div class="tags" v-if="program.tags && program.tags.length > 0">
              <span v-for="(t, i) in program.tags" class="tag is-annonce" :key="i">{{t}}</span>
            </div>
          </td>
          <td v-if="(isAdmin || isEditor) && showColumn('status')">
            <span class="tag" :class="tagColor(program.status)">{{program.status | workflowLabel}}</span>
          </td>
          <td v-if="showColumn('progress_step')">
            <span v-if="program.progress_step" class="tag is-info">{{programStepProgressLabel(program.progress_step)}}</span>
          </td>
          <td v-if="(isAdmin || isEditor) && showColumn('promotor_name')" class="is-cell-hoverable">
            <router-link :to="{name: 'PromoteurVue', params: {id: program.promoteur}}">
              {{program.promoteur_name}}
            </router-link>
          </td>
          <td v-if="(isAdmin || isEditor) && showColumn('diffusion_enabled')">
            <span v-if="program.diffusion_enabled">Oui</span><span v-else>Non</span>
          </td>
          <td v-if="showColumn('tax_dispositifs')">
            <span v-for="(tax, index) in program.tax_dispositifs" v-if="index < 2" :key="index">
              {{taxName(tax)}}<span>{{index === 0 && program.tax_dispositifs.length > 1 ? ', ' : index === 1 && program.tax_dispositifs.length > 1 ? '...' : ''}}</span>
            </span>
          </td>
          <td v-if="showColumn('lot_dispo')">{{program.lot_counts.available}}</td>
          <td v-if="showColumn('lot_total')">{{program.lot_counts.total}}</td>
          <td v-if="showColumn('city')">{{program.address.city}} - {{program.address.zip_code}}</td>
          <td v-if="showColumn('date_livraison')">
            <span v-if="program.date_livraison">{{program.date_livraison | trimestre}}</span>
            <span v-else></span>
          </td>
          <td v-if="!isExternal && showColumn('remuneration') && displayRemuneration">
            <span v-if="program.remuneration">{{program.remuneration}}%</span>
            <span v-else>--</span>
          </td>
          <td v-if="isAdmin && showColumn('created_on')">
            {{program.created_on | prettyDate }}
          </td>
          <td class="has-text-centered actions">
            <display-button-list :buttons="buttonList" :data="program"
                                 :is-checked="checkedItem(program.pk)"
                                 :multiselection="multiselection" @selected="selectItem">
            </display-button-list>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-show="!loading && !items.length">
      <div class="columns">
        <div class="column">
          <h2 class="title is-3 has-text-weight-bold">Aucun programme disponible</h2>
          <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
            class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="column has-bg-light is-border-bottom is-paddingless-top is-paddingless-bottom">
      <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                  :totalPage="totalPage"></pagination>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter, DefaultValues, ColumnConf, MultiSelection } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { exportXls } from '../../utils'

  export default {
    name: 'ProgramList',
    mixins: [GenericList, Sort, Filter, DefaultValues, ColumnConf, MultiSelection],
    computed: {
      ...mapState({
        states: 'states',
        promoteursList: 'promoteurs'
      }),
      ...mapGetters(['isAdmin', 'isSeller', 'isManager', 'isEditor', 'isExternal', 'displayRemuneration']),
      columnsShow () {
        const columns = {
          'picture': {
            label: 'Aperçu',
            mobile: true
          },
          'tax_dispositifs': {
            label: 'Dispositifs',
            mobile: true
          },
          'lot_dispo': {
            label: 'Lot disponibles',
            mobile: true
          },
          'lot_total': {
            label: 'Total des lots',
            mobile: true
          },
          'city': {
            label: 'Ville',
            mobile: true
          },
          'progress_step': {
            label: 'État d\'avancement',
            mobile: true
          },
          'date_livraison': {
            label: 'Date de livraison',
            mobile: true
          }
        }
        if (this.isAdmin || this.isEditor) {
          columns.promotor_name = {
            label: 'Promoteur',
            mobile: true
          }
          columns.status = {
            label: 'Statut',
            mobile: true
          }
          columns.diffusion_enabled = {
            label: 'Publication en cours',
            mobile: true
          }
          columns.created_on = {
            label: 'Date de création',
            mobile: true
          }
        }
        if ((this.isAdmin || this.isEditor) && this.displayRemuneration) {
          columns.remuneration = {
            label: 'Rémunération',
            mobile: true
          }
        }
        return columns
      }
    },
    data () {
      return {
        enableSaveQuery: true,
        columnsConfResource: 'program',
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fas', 'fa-check'],
            display: () => {
              return !this.multiselection && this.isAdmin
            },
            action: () => {
              this.multiselection = !this.multiselection
            },
            text: 'Sélection multiple'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fal', 'fa-ban'],
            display: () => {
              return this.multiselection
            },
            action: () => {
              this.multiselection = !this.multiselection
              this.clearSelectedItems()
            },
            text: 'Annuler'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['far', 'fa-file-excel'],
            display: () => {
              return this.isAdmin && !this.multiselection
            },
            action: () => {
              exportXls('programs-export', this.query)
            },
            text: 'Export .xls'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['far', 'fa-exchange-alt'],
            display: () => {
              return this.multiselection && this.selectedItems.length
            },
            action: () => {
              this.changeStatusSelection()
            },
            text: 'Changer statut sélection'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-plus-square'],
            needProfile: ['admin'],
            display: () => {
              return !this.multiselection
            },
            action: () => {
              this.$router.push({name: 'ProgramCreate'})
            },
            text: 'Nouveau Programme'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync'],
            action: () => {
              this.loadItems()
            }
          }
        ],
        buttonList: [
          {
            routeName: 'ProgramVue',
            icon: 'fas fa-file-invoice',
            text: 'Fiche programme'
          },
          {
            routeName: 'ProgramEdit',
            icon: 'fas fa-edit',
            text: 'Modifier fiche programme',
            needProfile: ['admin', 'editor']
          },
          {
            routeName: 'ProgramDocumentEdit',
            icon: 'fas fa-folders',
            text: 'Gestions documents',
            needProfile: ['admin', 'editor']
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer programme',
            needProfile: ['admin']
          }
        ],
        displayPromoteurSelect: true,
        loadDocuments: this.loadItems,
        service: this.$api.programService,
        promoteurs: [],
        filters: {
          status: ['available', 'private']
        },
        initFilters: {
          status: ['available', 'private']
        }
      }
    },
    watch: {
      'filters.promoteur' (v) {
        this.updatePromoteurFilter(v)
      }
    },
    methods: {
      tagColor (value) {
        const COLORS = {
          'private': 'is-private',
          'available': 'is-disponible',
          'draft': 'is-draft',
          'archived': 'is-draft'
        }
        return COLORS[value]
      },
      beforeGet () {
        if (this.query.promoteur && typeof this.query.promoteur === 'object') {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (!Array.isArray(this.query.status)) {
          this.query.status = [this.query.status]
          this.filters.status = [this.filters.status]
        }
      },
      updatePromoteurFilter (e) {
        this.$set(this.filters, 'promoteur', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getPromoteurs (query) {
        this.$api.promoteurService.get({name: query}).then(r => {
          this.promoteurs = r.data.items
        })
      },
      taxName (value) {
        if (!value) return ''
        value = value.toString().split('_').join(' ')
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    created () {
      // this.$set(this.filters, 'status', ['available'])
      Object.assign(this.filters, this.$route.query)
      this.changeFilters()

      this.promoteurs = this.promoteursList.slice()
    }
  }
</script>

<style>
  td .tags {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/program/ProgramList.vue